export const BONUS_GROUP = 1;
export const FINE_GROUP = 0;

export const BONUS_GROUP_ALT = 1;
export const FINE_GROUP_ALT = 0;
